<template>
  <div class="flex flex-col h-full">
    <Textarea
      v-model="noteText"
      rows="5"
      autoResize
      :placeholder="placeholder"
      class="w-full"
    />
    <drawer-footer
      class="mt-auto"
      :approve-label="approveLabel"
      :approveDisable="loading"
      :approveLoading="loading"
      @approve-click="save"
      @cancel-click="$emit('close')"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
  initialValue?: string;
  placeholder?: string;
  approveLabel?: string;
  onSave: (text: string) => Promise<void>;
}>();

const emit = defineEmits(['close']);

const noteText = ref(props.initialValue ?? '');
const loading = ref(false);

const save = async () => {
  loading.value = true;
  try {
    await props.onSave(noteText.value);
    emit('close');
  } finally {
    loading.value = false;
  }
};
</script>
